export const testPeople = {
  5: {
    luid: 5,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Ornery",
    given_name: "Number",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 665.7092892585079,
    y: 223.50708822121734,
    d2me: 1000,
  },
  6: {
    luid: 6,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Welcome",
    given_name: "Greedy",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 18.523110081519484,
    y: 603.127638519875,
    d2me: 1000,
  },
  7: {
    luid: 7,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Background",
    given_name: "Plain",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 844.7644878791359,
    y: 90.74469849252023,
    d2me: 1000,
  },
  8: {
    luid: 8,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Sunny",
    given_name: "Thorough",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 854.9593471462299,
    y: 387.37808142039,
    d2me: 1000,
  },
  9: {
    luid: 9,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Stylish",
    given_name: "Soupy",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 416.04465200701276,
    y: 842.5970934600655,
    d2me: 1000,
  },
  10: {
    luid: 10,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Wrap",
    given_name: "Baby",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 698.5369572544028,
    y: 450.82850522427003,
    d2me: 1000,
  },
  11: {
    luid: 11,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Euphoric",
    given_name: "Orderly",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 836.4191725381676,
    y: 409.3658215854483,
    d2me: 1000,
  },
  12: {
    luid: 12,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Debate",
    given_name: "Overlooked",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 68.06986400044033,
    y: 706.6942714765968,
    d2me: 1000,
  },
  13: {
    luid: 13,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Draft",
    given_name: "Woman",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 191.96806651531844,
    y: 220.84574915091994,
    d2me: 1000,
  },
  14: {
    luid: 14,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Fluid",
    given_name: "Funny",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 484.3338554265347,
    y: 275.5337672834353,
    d2me: 1000,
  },
  15: {
    luid: 15,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Fatherly",
    given_name: "Part",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 793.3039027012439,
    y: 430.0811359711942,
    d2me: 1000,
  },
  16: {
    luid: 16,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Rocky",
    given_name: "Adolescent",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 166.2508887613609,
    y: 344.2221679191928,
    d2me: 1000,
  },
  17: {
    luid: 17,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Joint",
    given_name: "Pertinent",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 552.611591305482,
    y: 36.43376963202884,
    d2me: 1000,
  },
  18: {
    luid: 18,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Sail",
    given_name: "Slushy",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 843.3985118989773,
    y: 821.8154043637958,
    d2me: 1000,
  },
  19: {
    luid: 19,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Majestic",
    given_name: "Prime",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 571.2483184796984,
    y: 240.2114514148804,
    d2me: 1000,
  },
  20: {
    luid: 20,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Impact",
    given_name: "Suck",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 104.22176473852056,
    y: 134.07596059831423,
    d2me: 1000,
  },
  21: {
    luid: 21,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Sinful",
    given_name: "Wet",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 386.57572567493656,
    y: 411.5850675933774,
    d2me: 1000,
  },
  22: {
    luid: 22,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Camera",
    given_name: "Club",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 573.9291204730082,
    y: 306.62890856149505,
    d2me: 1000,
  },
  23: {
    luid: 23,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Studio",
    given_name: "Squiggly",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 259.8525537142277,
    y: 99.1232547951482,
    d2me: 1000,
  },
  24: {
    luid: 24,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Deficient",
    given_name: "Accurate",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 687.8416492136434,
    y: 805.5287492045954,
    d2me: 1000,
  },
  25: {
    luid: 25,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Faithful",
    given_name: "Golden",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 45.991822672530866,
    y: 52.364577469424496,
    d2me: 1000,
  },
  26: {
    luid: 26,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Listen",
    given_name: "Sugary",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 396.0071221743779,
    y: 554.5460878555338,
    d2me: 1000,
  },
  27: {
    luid: 27,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Child",
    given_name: "Miss",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 363.57566344030175,
    y: 364.4575160864947,
    d2me: 1000,
  },
  28: {
    luid: 28,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Descriptive",
    given_name: "Mean",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 313.76054017336065,
    y: 378.58617772750756,
    d2me: 1000,
  },
  29: {
    luid: 29,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Worrisome",
    given_name: "Chocolate",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 421.74575123231926,
    y: 257.33758334117283,
    d2me: 1000,
  },
  30: {
    luid: 30,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Overlooked",
    given_name: "Immense",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 362.88837766623266,
    y: 648.6193353281283,
    d2me: 1000,
  },
  31: {
    luid: 31,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Half",
    given_name: "Consequence",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 577.9761238553152,
    y: 172.86391396312365,
    d2me: 1000,
  },
  32: {
    luid: 32,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Frightened",
    given_name: "Beloved",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 434.5085528902497,
    y: 251.58313067370443,
    d2me: 1000,
  },
  33: {
    luid: 33,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Short",
    given_name: "Offensive",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 862.2719700057335,
    y: 126.21654318381275,
    d2me: 1000,
  },
  34: {
    luid: 34,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Petty",
    given_name: "Apprehensive",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 168.16192353334498,
    y: 139.28657317413445,
    d2me: 1000,
  },
  35: {
    luid: 35,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Possession",
    given_name: "Grizzled",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 55.83847654531508,
    y: 411.89481738310394,
    d2me: 1000,
  },
  36: {
    luid: 36,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Speed",
    given_name: "Unlawful",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 866.599425129571,
    y: 727.5038475352236,
    d2me: 1000,
  },
  37: {
    luid: 37,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Loyal",
    given_name: "Boot",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 418.6502979593348,
    y: 248.23107126655367,
    d2me: 1000,
  },
  38: {
    luid: 38,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Big",
    given_name: "Unlined",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 541.0340264791636,
    y: 856.7629571848692,
    d2me: 1000,
  },
  39: {
    luid: 39,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Bunch",
    given_name: "Source",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 345.7635913406133,
    y: 407.3276025342552,
    d2me: 1000,
  },
  40: {
    luid: 40,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Zany",
    given_name: "Rocky",
    micOn: true,
    share: false,
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 101.57930317778859,
    y: 585.2098461352958,
    d2me: 1000,
  },
  41: {
    luid: 41,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Broad",
    given_name: "Fall",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 377.1803931469931,
    y: 63.81233318428705,
    d2me: 1000,
  },
  42: {
    luid: 42,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Purpose",
    given_name: "Wry",
    micOn: true,
    share: false,
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 280.9004577486759,
    y: 369.57796042479305,
    d2me: 1000,
  },
  43: {
    luid: 43,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Impractical",
    given_name: "Velvety",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 880.6648130407656,
    y: 206.24988918542994,
    d2me: 1000,
  },
  44: {
    luid: 44,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Courteous",
    given_name: "Yellow",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 117.42890866766317,
    y: 839.6157521273583,
    d2me: 1000,
  },
  45: {
    luid: 45,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Rude",
    given_name: "Conventional",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 301.5295346188626,
    y: 250.17069977757737,
    d2me: 1000,
  },
  46: {
    luid: 46,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Win",
    given_name: "Zany",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 456.8609189502159,
    y: 602.7650549586783,
    d2me: 1000,
  },
  47: {
    luid: 47,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Tremendous",
    given_name: "Married",
    micOn: true,
    share: "screen",
    camOn: true,
    shout: false,
    muted: false,
    shoutable: true,
    x: 40.693315121114196,
    y: 448.70839628759995,
    d2me: 1000,
  },
  48: {
    luid: 48,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Heavy",
    given_name: "Mixed",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 254.76828794864505,
    y: 628.2407589915426,
    d2me: 1000,
  },
  49: {
    luid: 49,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Painting",
    given_name: "Foot",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 740.7894040082047,
    y: 826.1237898966297,
    d2me: 1000,
  },
  50: {
    luid: 50,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Lesson",
    given_name: "Pace",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 713.1778672616274,
    y: 391.1628336910953,
    d2me: 1000,
  },
  51: {
    luid: 51,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Sweet",
    given_name: "Initiative",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 854.3834708849652,
    y: 727.5797872428072,
    d2me: 1000,
  },
  52: {
    luid: 52,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Aromatic",
    given_name: "Sail",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 473.84471484468577,
    y: 50.78772825898022,
    d2me: 1000,
  },
  53: {
    luid: 53,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Bright",
    given_name: "Breakable",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 348.2518884766814,
    y: 94.28872259719057,
    d2me: 1000,
  },
  54: {
    luid: 54,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Friend",
    given_name: "Important",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 706.5468541040939,
    y: 681.8217795326851,
    d2me: 1000,
  },
  55: {
    luid: 55,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Shy",
    given_name: "Slide",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 571.5783731432016,
    y: 646.5315749076204,
    d2me: 1000,
  },
  56: {
    luid: 56,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Window",
    given_name: "Race",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 698.2376164464995,
    y: 295.33186909971926,
    d2me: 1000,
  },
  57: {
    luid: 57,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: null,
    family_name: "Bossy",
    given_name: "Pizza",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 655.7844499572589,
    y: 742.0015891214589,
    d2me: 1000,
  },
  58: {
    luid: 58,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "High-level",
    given_name: "Ironclad",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 424.20709138175744,
    y: 87.49994031947796,
    d2me: 1000,
  },
  59: {
    luid: 59,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Science",
    given_name: "Belt",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 648.1772535801939,
    y: 79.22074995648515,
    d2me: 1000,
  },
  60: {
    luid: 60,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Notable",
    given_name: "Unimportant",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 878.3202872347135,
    y: 406.78379207406755,
    d2me: 1000,
  },
  61: {
    luid: 61,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Sudden",
    given_name: "Second",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 756.7484401159645,
    y: 459.8214609602754,
    d2me: 1000,
  },
  62: {
    luid: 62,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Cost",
    given_name: "Resist",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 461.242544911624,
    y: 457.673406477295,
    d2me: 1000,
  },
  63: {
    luid: 63,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Familiar",
    given_name: "Value",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 19.215436102046972,
    y: 531.5544397055759,
    d2me: 1000,
  },
  64: {
    luid: 64,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Joyful",
    given_name: "Forceful",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 415.3315090045014,
    y: 33.91724218612979,
    d2me: 1000,
  },
  65: {
    luid: 65,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Extroverted",
    given_name: "Storage",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 539.606262367512,
    y: 704.5317587989866,
    d2me: 1000,
  },
  66: {
    luid: 66,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Wrong",
    given_name: "Spirited",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 861.8111322545733,
    y: 760.9901856538538,
    d2me: 1000,
  },
  67: {
    luid: 67,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Range",
    given_name: "Pause",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 354.6628355738158,
    y: 151.4958213030205,
    d2me: 1000,
  },
  68: {
    luid: 68,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Tone",
    given_name: "Innocent",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 58.36652091210444,
    y: 775.3056472086314,
    d2me: 1000,
  },
  69: {
    luid: 69,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Death",
    given_name: "Combine",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 239.01330857531642,
    y: 161.9292589643992,
    d2me: 1000,
  },
  70: {
    luid: 70,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Loose",
    given_name: "Attitude",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 866.0155228454896,
    y: 589.1098606746704,
    d2me: 1000,
  },
  71: {
    luid: 71,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Lack",
    given_name: "Sane",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 870.1431834814447,
    y: 470.86114822879074,
    d2me: 1000,
  },
  72: {
    luid: 72,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Tooth",
    given_name: "Upright",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 274.5999567061835,
    y: 340.7417544253647,
    d2me: 1000,
  },
  73: {
    luid: 73,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Catch",
    given_name: "Hospitable",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 583.7000480976271,
    y: 366.71833565451624,
    d2me: 1000,
  },
  74: {
    luid: 74,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Construction",
    given_name: "Crushing",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 480.056854984145,
    y: 153.04686614436983,
    d2me: 1000,
  },
  75: {
    luid: 75,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Silly",
    given_name: "Clerk",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 534.314714690336,
    y: 453.49766567783917,
    d2me: 1000,
  },
  76: {
    luid: 76,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Bed",
    given_name: "Drawing",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 138.53998890563247,
    y: 456.9042509320648,
    d2me: 1000,
  },
  77: {
    luid: 77,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Wonderful",
    given_name: "Author",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 811.4203208423576,
    y: 743.0540593970502,
    d2me: 1000,
  },
  78: {
    luid: 78,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Productive",
    given_name: "Frizzy",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 676.0706686154311,
    y: 185.99161798090847,
    d2me: 1000,
  },
  79: {
    luid: 79,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Bank",
    given_name: "Detail",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 270.99647584595215,
    y: 462.32385704472625,
    d2me: 1000,
  },
  80: {
    luid: 80,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Trivial",
    given_name: "Benefit",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 104.829508435225,
    y: 464.8309259681569,
    d2me: 1000,
  },
  81: {
    luid: 81,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Admired",
    given_name: "Improvement",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 319.4518297905327,
    y: 632.2156238672134,
    d2me: 1000,
  },
  82: {
    luid: 82,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Island",
    given_name: "Charming",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 236.53633806453882,
    y: 863.3692996042358,
    d2me: 1000,
  },
  83: {
    luid: 83,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Moment",
    given_name: "Honored",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 824.222384735924,
    y: 363.8663394813061,
    d2me: 1000,
  },
  84: {
    luid: 84,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Camera",
    given_name: "Ambitious",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 166.6117275453724,
    y: 752.9525187712013,
    d2me: 1000,
  },
  85: {
    luid: 85,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Shocked",
    given_name: "Bruised",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 752.883890682302,
    y: 676.4567626409299,
    d2me: 1000,
  },
  86: {
    luid: 86,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Awareness",
    given_name: "Black",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 512.6917052063064,
    y: 816.5640330033045,
    d2me: 1000,
  },
  87: {
    luid: 87,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Read",
    given_name: "Tap",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 379.7611929956599,
    y: 90.22011077477154,
    d2me: 1000,
  },
  88: {
    luid: 88,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Lunch",
    given_name: "Ragged",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 710.9606571008707,
    y: 331.7221022196148,
    d2me: 1000,
  },
  89: {
    luid: 89,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Conscious",
    given_name: "Elegant",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 822.7899861644412,
    y: 808.1933622889237,
    d2me: 1000,
  },
  90: {
    luid: 90,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Winged",
    given_name: "Fatherly",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 722.0968332591901,
    y: 564.9537403445552,
    d2me: 1000,
  },
  91: {
    luid: 91,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Code",
    given_name: "Weird",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 624.1852391751364,
    y: 383.7729154679365,
    d2me: 1000,
  },
  92: {
    luid: 92,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Foundation",
    given_name: "Cow",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 580.6746581065678,
    y: 675.0993351009176,
    d2me: 1000,
  },
  93: {
    luid: 93,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Solid",
    given_name: "Insecure",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 666.2565062104679,
    y: 831.1283635642309,
    d2me: 1000,
  },
  94: {
    luid: 94,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Different",
    given_name: "Witty",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 729.4963564842014,
    y: 643.5325929719254,
    d2me: 1000,
  },
  95: {
    luid: 95,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Price",
    given_name: "Shimmering",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 57.27149409452738,
    y: 402.229939174366,
    d2me: 1000,
  },
  96: {
    luid: 96,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Boot",
    given_name: "Tragic",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 651.3365392225267,
    y: 624.1427191580045,
    d2me: 1000,
  },
  97: {
    luid: 97,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Unruly",
    given_name: "Punch",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 588.4511680026461,
    y: 81.92437039199318,
    d2me: 1000,
  },
  98: {
    luid: 98,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "White",
    given_name: "Variety",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 181.13387452882276,
    y: 542.0147790708235,
    d2me: 1000,
  },
  99: {
    luid: 99,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Crew",
    given_name: "Introduction",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 599.8810142516178,
    y: 46.76256077865355,
    d2me: 1000,
  },
  100: {
    luid: 100,
    uuid: "asb3-skjsn-kjhs786",
    admin: false,
    avatar_key: "d58dca50-4164-4821-98ad-ed12a4ab1da6",
    family_name: "Valid",
    given_name: "Machine",
    micOn: true,
    share: "screen",
    camOn: false,
    shout: false,
    muted: false,
    shoutable: true,
    x: 223.35234687669168,
    y: 644.4534713388006,
    d2me: 1000,
  },
};
